import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getNodeProperty } from 'libs/quill-utils';
import { subtitlesDefaults } from 'api/settings/user-settings';
import SpeakerColorButton from '../SpeakerColorButton';
import SpeakerSign from '../SpeakerSign';
import SpeakerTimestamp from '../SpeakerTimestamp';
import SpeakerCitation from '../SpeakerCitation';
const SpeakerWidget = ({ position, widgetTrigger, disabled, isCaptionMode, editorController, }) => {
    const getSpeakerColor = () => {
        var _a;
        // NOTE: The change in initial color (prop) enables to properly re-render
        // the SpeakerColorButton component, when the parent component is re-rendered.
        const defaultColor = (_a = editorController.captions.parameters) === null || _a === void 0 ? void 0 : _a.defaultColor;
        if (defaultColor !== undefined) {
            const captionColor = getNodeProperty(widgetTrigger, 'caption-color-');
            return captionColor !== null && captionColor !== void 0 ? captionColor : defaultColor;
        }
        return subtitlesDefaults.speakerColor;
    };
    return (_jsxs(_Fragment, { children: [_jsx(SpeakerTimestamp, { position: position, widgetTrigger: widgetTrigger }), _jsx(SpeakerCitation, { position: position, widgetTrigger: widgetTrigger, disabled: disabled, editorController: editorController }), isCaptionMode === true && (_jsxs(_Fragment, { children: [_jsx(SpeakerColorButton, { widgetTrigger: widgetTrigger, position: position, disabled: disabled, editorController: editorController, initialColor: getSpeakerColor() }), _jsx(SpeakerSign, { position: position, widgetTrigger: widgetTrigger, disabled: disabled, editorController: editorController })] }))] }));
};
export default SpeakerWidget;
